/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AllocationName } from '../models/AllocationName';
import type { CapTableName } from '../models/CapTableName';
import type { Company } from '../models/Company';
import type { CompanyQuestionSync } from '../models/CompanyQuestionSync';
import type { Investment } from '../models/Investment';
import type { RetrieveDocumentGenerationJob } from '../models/RetrieveDocumentGenerationJob';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CompaniesService {
    /**
     * @param cmdId
     * @returns any
     * @throws ApiError
     */
    public static apiCompaniesFiscalEndDatesRead(
        cmdId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies/fiscal-end-dates/{cmd_id}',
            path: {
                'cmd_id': cmdId,
            },
        });
    }
    /**
     * Extract tables from specified PDF pages and return as Excel data.
     * Expected request data:
     * {
         * "page_numbers": [1, 2, 3]  # List of page numbers to process
         * }
         * @param companyId
         * @param fileId
         * @param data
         * @returns RetrieveDocumentGenerationJob
         * @throws ApiError
         */
        public static apiCompaniesDocumentsConversionCreate(
            companyId: string,
            fileId: string,
            data: RetrieveDocumentGenerationJob,
        ): CancelablePromise<RetrieveDocumentGenerationJob> {
            return __request(OpenAPI, {
                method: 'POST',
                url: '/api/companies/{company_id}/documents/{file_id}/conversion',
                path: {
                    'company_id': companyId,
                    'file_id': fileId,
                },
                body: data,
            });
        }
        /**
         * @param companyPk
         * @returns any
         * @throws ApiError
         */
        public static apiCompaniesAllocationValuesRead(
            companyPk: string,
        ): CancelablePromise<any> {
            return __request(OpenAPI, {
                method: 'GET',
                url: '/api/companies/{company_pk}/allocation-values',
                path: {
                    'company_pk': companyPk,
                },
            });
        }
        /**
         * @param id A unique integer value identifying this company.
         * @returns Company
         * @throws ApiError
         */
        public static apiCompaniesRead(
            id: number,
        ): CancelablePromise<Company> {
            return __request(OpenAPI, {
                method: 'GET',
                url: '/api/companies/{id}',
                path: {
                    'id': id,
                },
            });
        }
        /**
         * @param id A unique integer value identifying this company.
         * @param data
         * @returns Company
         * @throws ApiError
         */
        public static apiCompaniesUpdate(
            id: number,
            data: Company,
        ): CancelablePromise<Company> {
            return __request(OpenAPI, {
                method: 'PUT',
                url: '/api/companies/{id}',
                path: {
                    'id': id,
                },
                body: data,
            });
        }
        /**
         * @param id A unique integer value identifying this company.
         * @param data
         * @returns Company
         * @throws ApiError
         */
        public static apiCompaniesPartialUpdate(
            id: number,
            data: Company,
        ): CancelablePromise<Company> {
            return __request(OpenAPI, {
                method: 'PATCH',
                url: '/api/companies/{id}',
                path: {
                    'id': id,
                },
                body: data,
            });
        }
        /**
         * @param id A unique integer value identifying this company.
         * @returns void
         * @throws ApiError
         */
        public static apiCompaniesDelete(
            id: number,
        ): CancelablePromise<void> {
            return __request(OpenAPI, {
                method: 'DELETE',
                url: '/api/companies/{id}',
                path: {
                    'id': id,
                },
            });
        }
        /**
         * @param id
         * @param page A page number within the paginated result set.
         * @returns any
         * @throws ApiError
         */
        public static apiCompaniesAllocationsList(
            id: string,
            page?: number,
        ): CancelablePromise<{
            count: number;
            next?: string | null;
            previous?: string | null;
            results: Array<AllocationName>;
        }> {
            return __request(OpenAPI, {
                method: 'GET',
                url: '/api/companies/{id}/allocations',
                path: {
                    'id': id,
                },
                query: {
                    'page': page,
                },
            });
        }
        /**
         * @param id
         * @param fileType
         * @returns any
         * @throws ApiError
         */
        public static apiCompaniesAssetSignedUrlRead(
            id: string,
            fileType: string,
        ): CancelablePromise<any> {
            return __request(OpenAPI, {
                method: 'GET',
                url: '/api/companies/{id}/asset-signed-url/{file_type}',
                path: {
                    'id': id,
                    'file_type': fileType,
                },
            });
        }
        /**
         * @param id
         * @param page A page number within the paginated result set.
         * @param mp Measurement date ID
         * @param cmd Command ID for measurement date
         * @param includeConvertibleNotes Include convertible notes in the response
         * @returns CapTableName
         * @throws ApiError
         */
        public static apiCompaniesCapTablesList(
            id: string,
            page?: number,
            mp?: number,
            cmd?: number,
            includeConvertibleNotes: boolean = false,
        ): CancelablePromise<Array<CapTableName>> {
            return __request(OpenAPI, {
                method: 'GET',
                url: '/api/companies/{id}/cap-tables',
                path: {
                    'id': id,
                },
                query: {
                    'page': page,
                    'mp': mp,
                    'cmd': cmd,
                    'include_convertible_notes': includeConvertibleNotes,
                },
            });
        }
        /**
         * @param id
         * @param mdId
         * @returns any
         * @throws ApiError
         */
        public static apiCompaniesHasSummaryRead(
            id: string,
            mdId: string,
        ): CancelablePromise<any> {
            return __request(OpenAPI, {
                method: 'GET',
                url: '/api/companies/{id}/has-summary/{md_id}',
                path: {
                    'id': id,
                    'md_id': mdId,
                },
            });
        }
        /**
         * Returns a list of investments for a company at a specific measurement date
         * @param id
         * @param mdId
         * @returns Investment A list of Investments
         * @throws ApiError
         */
        public static apiCompaniesSummaryRead(
            id: string,
            mdId: string,
        ): CancelablePromise<Array<Investment>> {
            return __request(OpenAPI, {
                method: 'GET',
                url: '/api/companies/{id}/summary/{md_id}',
                path: {
                    'id': id,
                    'md_id': mdId,
                },
            });
        }
        /**
         * @param id A unique integer value identifying this company.
         * @param data
         * @returns CompanyQuestionSync
         * @throws ApiError
         */
        public static apiCompaniesSyncCompanyQuestionsUpdate(
            id: number,
            data: CompanyQuestionSync,
        ): CancelablePromise<CompanyQuestionSync> {
            return __request(OpenAPI, {
                method: 'PUT',
                url: '/api/companies/{id}/sync-company-questions',
                path: {
                    'id': id,
                },
                body: data,
            });
        }
        /**
         * @param id A unique integer value identifying this company.
         * @param data
         * @returns CompanyQuestionSync
         * @throws ApiError
         */
        public static apiCompaniesSyncCompanyQuestionsPartialUpdate(
            id: number,
            data: CompanyQuestionSync,
        ): CancelablePromise<CompanyQuestionSync> {
            return __request(OpenAPI, {
                method: 'PATCH',
                url: '/api/companies/{id}/sync-company-questions',
                path: {
                    'id': id,
                },
                body: data,
            });
        }
    }
